import React from 'react';
import { Card, CardBody, CardTitle, CardText } from 'reactstrap';

export default function PublicRelationsOfficerCard() {
    return (
        <div className="container mt-5 mb-5">
            <Card className="shadow border-0 rounded-4">
                <CardBody className="p-4">
                    <CardTitle tag="h4" className="text-center fw-bold">
                        जनसम्पर्क अधिकारी कार्यालय (PRO)
                    </CardTitle>
                    <hr />
                    <CardText className="fs-5 ">
                        <strong className='text-primary'>डॉ. गोविन्द बल्लभ</strong><br />
                        जन सम्पर्क अधिकारी<br />
                        <strong>संपर्क:</strong> 70115-04209<br />
                        <strong>ई-मेल:</strong>{' '}
                        <a href="mailto:pro@mvsu.ac.in">pro@mvsu.ac.in</a><br />
                        टीक परिसर -
                        महर्षि वाल्मीकि संस्कृत विश्वविद्यालय<br />
                        कुरुक्षेत्र मार्ग, कैथल (हरियाणा) – 136027
                    </CardText>
                </CardBody>
            </Card>
        </div>
    );
}
